var _defs, _path, _path2, _g, _g2, _g3, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _mask, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgEmptySquadChallenge = function SvgEmptySquadChallenge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 456,
    height: 257,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50.007%",
    x2: "100.001%",
    y2: "50.007%",
    id: "EmptySquadChallenge_svg__a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4C8E2",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D7DAEB",
    offset: "14.5%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4F5FA",
    offset: "40.6%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    offset: "55.5%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "54.272%",
    y1: "-36.945%",
    x2: "50%",
    y2: "89.738%",
    id: "EmptySquadChallenge_svg__d"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#54AFAE",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2A7776",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "54.272%",
    y1: "-36.945%",
    x2: "50%",
    y2: "109.746%",
    id: "EmptySquadChallenge_svg__g"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#54AFAE",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2A7776",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "8.585%",
    x2: "50%",
    y2: "125.022%",
    id: "EmptySquadChallenge_svg__j"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#54AFAE",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2A7776",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50%",
    x2: "100%",
    y2: "50%",
    id: "EmptySquadChallenge_svg__k"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFD5F1",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E5F6",
    offset: "28.3%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F8FD",
    offset: "71.9%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50.002%",
    x2: "100%",
    y2: "50.002%",
    id: "EmptySquadChallenge_svg__l"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFD5F1",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E5F6",
    offset: "28.3%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F8FD",
    offset: "71.9%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-.001%",
    y1: "50%",
    x2: "100%",
    y2: "50%",
    id: "EmptySquadChallenge_svg__m"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2C8E7",
    offset: "42.7%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C9CEEA",
    offset: "55.9%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDEF1",
    offset: "74.5%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F9FD",
    offset: "96.1%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50%",
    x2: "100%",
    y2: "50%",
    id: "EmptySquadChallenge_svg__n"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2C8E7",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    offset: "91.6%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "49.999%",
    x2: "100%",
    y2: "49.999%",
    id: "EmptySquadChallenge_svg__o"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#67CAC9",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#358685",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50%",
    x2: "100.002%",
    y2: "50%",
    id: "EmptySquadChallenge_svg__p"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2C8E7",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "49.997%",
    x2: "100%",
    y2: "49.997%",
    id: "EmptySquadChallenge_svg__q"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FB944B",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D96D36",
    offset: "61.4%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C85A2B",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50%",
    x2: "100%",
    y2: "50%",
    id: "EmptySquadChallenge_svg__r"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FB944B",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D96D36",
    offset: "61.4%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C85A2B",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: ".004%",
    y1: "49.997%",
    x2: "100%",
    y2: "49.997%",
    id: "EmptySquadChallenge_svg__s"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFCFE",
    offset: "14%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8ECF7",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50%",
    x2: "100%",
    y2: "50%",
    id: "EmptySquadChallenge_svg__t"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FB944B",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3653B",
    offset: "61.4%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F63",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50%",
    x2: "100%",
    y2: "50%",
    id: "EmptySquadChallenge_svg__u"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC4C26",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4582F",
    offset: "24.2%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E96C42",
    offset: "61.1%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8056",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "49.999%",
    x2: "100%",
    y2: "49.999%",
    id: "EmptySquadChallenge_svg__v"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFD5F1",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E5F6",
    offset: "28.3%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F8FD",
    offset: "71.9%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "49.999%",
    x2: "100%",
    y2: "49.999%",
    id: "EmptySquadChallenge_svg__w"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFD5F1",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E5F6",
    offset: "28.3%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F8FD",
    offset: "71.9%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50%",
    x2: "100%",
    y2: "50%",
    id: "EmptySquadChallenge_svg__x"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFD5F1",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E5F6",
    offset: "28.3%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F8FD",
    offset: "71.9%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50%",
    x2: "100%",
    y2: "50%",
    id: "EmptySquadChallenge_svg__y"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4C9E5",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C9CEE7",
    offset: "7.6%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0F1F8",
    offset: "68.3%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "49.999%",
    x2: "99.999%",
    y2: "49.999%",
    id: "EmptySquadChallenge_svg__A"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4C9E4",
    offset: "42.7%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D7DAED",
    offset: "57.7%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4F5FA",
    offset: "84.6%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50%",
    x2: "100%",
    y2: "50%",
    id: "EmptySquadChallenge_svg__B"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC16B",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDBC68",
    offset: "5.1%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0934E",
    offset: "46.9%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87A3F",
    offset: "79.9%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E57139",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-.001%",
    y1: "50%",
    x2: "100%",
    y2: "50%",
    id: "EmptySquadChallenge_svg__C"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4C9E4",
    offset: "42.7%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D7DAED",
    offset: "57.7%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4F5FA",
    offset: "84.6%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50%",
    x2: "100%",
    y2: "50%",
    id: "EmptySquadChallenge_svg__D"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC16B",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDBC68",
    offset: "5.1%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0934E",
    offset: "46.9%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87A3F",
    offset: "79.9%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E57139",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50%",
    x2: "100%",
    y2: "50%",
    id: "EmptySquadChallenge_svg__E"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFD5F1",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEF0FA",
    offset: "58.9%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50%",
    x2: "100%",
    y2: "50%",
    id: "EmptySquadChallenge_svg__F"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFD5F1",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E5F6",
    offset: "28.3%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F8FD",
    offset: "71.9%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50%",
    x2: "100%",
    y2: "50%",
    id: "EmptySquadChallenge_svg__G"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFD5F1",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E5F6",
    offset: "28.3%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F8FD",
    offset: "71.9%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50.001%",
    x2: "100%",
    y2: "50.001%",
    id: "EmptySquadChallenge_svg__H"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFD5F1",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E5F6",
    offset: "28.3%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F8FD",
    offset: "71.9%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50%",
    x2: "100%",
    y2: "50%",
    id: "EmptySquadChallenge_svg__I"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFD5F1",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E5F6",
    offset: "28.3%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F8FD",
    offset: "71.9%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50%",
    x2: "99.999%",
    y2: "50%",
    id: "EmptySquadChallenge_svg__J"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE0F5",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2E7F6",
    offset: "65.6%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8ECF7",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50.004%",
    x2: "100%",
    y2: "50.004%",
    id: "EmptySquadChallenge_svg__K"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFD5F1",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0E5F5",
    offset: "55.3%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8ECF7",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "49.999%",
    x2: "100%",
    y2: "49.999%",
    id: "EmptySquadChallenge_svg__L"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFD5F1",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E5F6",
    offset: "28.3%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F8FD",
    offset: "71.9%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50%",
    x2: "100%",
    y2: "50%",
    id: "EmptySquadChallenge_svg__M"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CED3F8",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5ABCC",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50%",
    x2: "100%",
    y2: "50%",
    id: "EmptySquadChallenge_svg__N"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5ABCC",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CED3F8",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50%",
    x2: "100%",
    y2: "50%",
    id: "EmptySquadChallenge_svg__O"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5ABCC",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CED3F8",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50%",
    x2: "100%",
    y2: "50%",
    id: "EmptySquadChallenge_svg__P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CED3F8",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5ABCC",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50%",
    x2: "100%",
    y2: "50%",
    id: "EmptySquadChallenge_svg__Q"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5ABCC",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CED3F8",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50%",
    x2: "100.003%",
    y2: "50%",
    id: "EmptySquadChallenge_svg__R"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5ABCC",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CED3F8",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50.003%",
    x2: "100%",
    y2: "50.003%",
    id: "EmptySquadChallenge_svg__U"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6CBE7",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CED2EA",
    offset: "7.7%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9EBF6",
    offset: "39.8%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9FAFD",
    offset: "68.2%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    offset: "89.9%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "707.513%",
    y1: "49.997%",
    x2: "807.511%",
    y2: "49.997%",
    id: "EmptySquadChallenge_svg__V"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6CBE7",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CED2EA",
    offset: "7.7%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9EBF6",
    offset: "39.8%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9FAFD",
    offset: "68.2%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    offset: "89.9%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "100.001%",
    y1: "50%",
    x2: "0%",
    y2: "50%",
    id: "EmptySquadChallenge_svg__W"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5555C6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5251C0",
    offset: "6.6%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4140A5",
    offset: "43%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#373595",
    offset: "75.4%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#34318F",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-991.936%",
    y1: "50%",
    x2: "-891.934%",
    y2: "50%",
    id: "EmptySquadChallenge_svg__X"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5555C6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5251C0",
    offset: "6.6%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4140A5",
    offset: "43%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#373595",
    offset: "75.4%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#34318F",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "48.99%",
    y1: "0%",
    x2: "52.19%",
    y2: "109.395%",
    id: "EmptySquadChallenge_svg__Y"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F63",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DE5020",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "100%",
    y1: "50%",
    x2: ".001%",
    y2: "50%",
    id: "EmptySquadChallenge_svg__Z"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CED3F8",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6F6FB",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "100.001%",
    y1: "50%",
    x2: ".001%",
    y2: "50%",
    id: "EmptySquadChallenge_svg__aa"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8ECF7",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F3FA",
    offset: "33.2%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m406.565 57.788-19.58-28.858s-19.882 29.28-20.014 29.493a7.72 7.72 0 0 0-1.224 4.083c0 3.118 2.074 6.235 6.22 8.615 8.294 4.757 21.74 4.757 30.033 0 4.147-2.38 6.22-5.497 6.22-8.615a7.961 7.961 0 0 0-1.656-4.718Z",
    id: "EmptySquadChallenge_svg__c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m404.145 46.112-17.16-25.291-17.161 25.29a6.978 6.978 0 0 0-1.452 4.136c0 2.731 1.818 5.463 5.451 7.549 7.269 4.17 19.053 4.17 26.32 0 3.635-2.086 5.454-4.818 5.454-7.55a6.993 6.993 0 0 0-1.452-4.134Z",
    id: "EmptySquadChallenge_svg__f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.96 36.478c-.098-.16-14.976-22.073-14.976-22.073s-14.878 21.913-14.977 22.074a5.768 5.768 0 0 0-.915 3.053c0 2.334 1.551 4.667 4.654 6.447 6.207 3.56 16.27 3.56 22.476 0 3.103-1.78 4.654-4.113 4.654-6.447a5.768 5.768 0 0 0-.915-3.053Z",
    id: "EmptySquadChallenge_svg__i"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6.007 85.006 1.802-3.23c9.98 1.832 20.541 1.254 29.518-1.405V0H0v89.777h6.007v-4.771Z",
    id: "EmptySquadChallenge_svg__S"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-22.4%",
    y: "-12%",
    width: "144.7%",
    height: "141.5%",
    filterUnits: "objectBoundingBox",
    id: "EmptySquadChallenge_svg__b"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 4,
    "in": "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    "in": "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.202824519 0",
    "in": "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-25.5%",
    y: "-13.7%",
    width: "151%",
    height: "147.4%",
    filterUnits: "objectBoundingBox",
    id: "EmptySquadChallenge_svg__e"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 4,
    "in": "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    "in": "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.202824519 0",
    "in": "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-29.9%",
    y: "-16.1%",
    width: "159.8%",
    height: "155.5%",
    filterUnits: "objectBoundingBox",
    id: "EmptySquadChallenge_svg__h"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 4,
    "in": "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    "in": "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.202824519 0",
    "in": "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "23.499%",
    cy: "30.853%",
    fx: "23.499%",
    fy: "30.853%",
    r: "81.935%",
    gradientTransform: "matrix(.99361 0 0 1 .002 0)",
    id: "EmptySquadChallenge_svg__z"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#78E3E2",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2A7776",
    offset: "100%"
  })))), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#EmptySquadChallenge_svg__a)",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "multiply"
    },
    d: "M386.984 81.227h29.703v2.23h-29.703z"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#20196F",
    fillRule: "nonzero",
    d: "m386.984 83.458-1.78-1.02V62.506l1.78 1.02z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#110F42",
    fillRule: "nonzero",
    d: "m386.984 83.458 1.78-1.02V62.506l-1.78 1.02z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#EmptySquadChallenge_svg__b)",
    xlinkHref: "#EmptySquadChallenge_svg__c"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#EmptySquadChallenge_svg__d)",
    xlinkHref: "#EmptySquadChallenge_svg__c"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#EmptySquadChallenge_svg__e)",
    xlinkHref: "#EmptySquadChallenge_svg__f"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#EmptySquadChallenge_svg__g)",
    xlinkHref: "#EmptySquadChallenge_svg__f"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#EmptySquadChallenge_svg__h)",
    xlinkHref: "#EmptySquadChallenge_svg__i"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#EmptySquadChallenge_svg__j)",
    xlinkHref: "#EmptySquadChallenge_svg__i"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "url(#EmptySquadChallenge_svg__k)",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "multiply"
    },
    d: "M18.605 135.159H7.157l7.157 4.233-7.157 4.106h11.448l7.266-4.169-7.266-4.17z"
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#2B7978",
    fillRule: "nonzero",
    d: "m7.157 143.498 7.157-4.106v-8.338l-7.157 4.105v8.339z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#57B5B4",
    fillRule: "nonzero",
    d: "M7.157 143.498 0 139.392v-8.338l7.157 4.105z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#74DDDC",
    fillRule: "nonzero",
    d: "M7.157 135.159 0 131.054l7.157-4.103 7.157 4.103-7.157 4.105z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#EmptySquadChallenge_svg__l)",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "multiply"
    },
    d: "M440.685 150.758h-10.528l6.582 3.892-6.582 3.777h10.528l6.684-3.834-6.684-3.835z"
  }), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#E57139",
    fillRule: "nonzero",
    d: "m430.157 158.427 6.582-3.777v-7.668l-6.582 3.776z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#FB944B",
    fillRule: "nonzero",
    d: "m430.157 158.427-6.582-3.777v-7.668l6.582 3.776z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFAF6D",
    fillRule: "nonzero",
    d: "m430.157 150.758-6.582-3.776 6.582-3.774 6.582 3.774z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M78.971 174.176v-3.15c-3.39-1.945-5.948-6.24-5.948-9.987v-12.815l8.065 4.626v-3.15l-10.81-6.2v15.963c0 5.453 3.818 11.917 8.693 14.713Z",
    fill: "#FB944B",
    fillRule: "nonzero"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFAF6D",
    fillRule: "nonzero",
    d: "m70.278 143.5 2.745-1.576 10.81 6.202-2.745 1.574z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M75.768 149.799v9.664c0 3.75 2.558 8.044 5.95 9.989l-2.747 1.574c-3.39-1.945-5.948-6.24-5.948-9.987v-12.815l2.745 1.575Z",
    fill: "#C85A2B",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M100.538 224.798c6.577-3.775 17.245-3.775 23.823 0 6.578 3.773 6.578 9.892 0 13.666-6.578 3.773-17.246 3.773-23.823 0-6.579-3.774-6.579-9.893 0-13.666Z",
    fill: "url(#EmptySquadChallenge_svg__m)",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "multiply"
    }
  }), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M95.53 221.536c6.579-3.775 17.245-3.775 23.824 0 6.579 3.774 6.579 9.893 0 13.666-6.579 3.774-17.244 3.774-23.824 0-6.577-3.773-6.577-9.892 0-13.666Z",
    fill: "#F5F5F9",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M107.443 233.172h14.62c2.786-2.79 2.95-6.204.495-9.067h-15.115v9.067Z",
    fill: "url(#EmptySquadChallenge_svg__n)",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "multiply"
    }
  }), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M119.354 235.202c-6.579 3.774-17.244 3.774-23.824 0-3.289-1.887-4.934-4.36-4.934-6.833v3.26c0 2.474 1.645 4.949 4.934 6.835 6.58 3.773 17.245 3.773 23.824 0 3.29-1.886 4.935-4.36 4.935-6.834v-3.261c0 2.473-1.645 4.946-4.935 6.833Z",
    fill: "url(#EmptySquadChallenge_svg__o)",
    fillRule: "nonzero"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M101.524 221.712c3.268-1.874 8.569-1.874 11.837 0 3.268 1.875 3.268 4.917 0 6.79-3.268 1.875-8.569 1.875-11.837 0-3.269-1.874-3.269-4.915 0-6.79Z",
    fill: "#FFAF6D",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M107.443 227.508h7.24c1.5-1.488 1.493-3.334-.019-4.818h-7.22v4.818Z",
    fill: "url(#EmptySquadChallenge_svg__p)",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "multiply"
    }
  }), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M113.36 228.503c-3.267 1.874-8.568 1.874-11.836 0-1.634-.939-2.45-2.166-2.45-3.395v3.261c0 1.23.816 2.458 2.45 3.395 3.268 1.876 8.569 1.876 11.837 0 1.634-.937 2.451-2.166 2.451-3.395v-3.261c0 1.229-.817 2.457-2.451 3.395Z",
    fill: "url(#EmptySquadChallenge_svg__q)",
    fillRule: "nonzero"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M103.258 209.922v15.186c0 .613.408 1.228 1.226 1.697 1.634.937 4.284.937 5.917 0 .817-.47 1.225-1.084 1.225-1.697v-15.186h-8.368Z",
    fill: "url(#EmptySquadChallenge_svg__r)",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M103.258 213.178c0 .615.408 1.229 1.226 1.698 1.634.937 4.284.937 5.917 0 .817-.47 1.225-1.083 1.225-1.698v-3.256h-8.369v3.256Z",
    fill: "url(#EmptySquadChallenge_svg__s)",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "multiply"
    }
  }), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M143.356 160.351H71.528c0 25.176 17.658 51.97 35.915 51.97 18.257 0 35.913-26.794 35.913-51.97Z",
    fill: "url(#EmptySquadChallenge_svg__t)",
    fillRule: "nonzero"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M82.049 145.783c14.024-8.045 36.764-8.045 50.788 0 14.025 8.046 14.025 21.091 0 29.137-14.024 8.046-36.764 8.046-50.788 0-14.027-8.046-14.027-21.091 0-29.137Z",
    fill: "#FFAF6D",
    fillRule: "nonzero"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M84.075 146.947c12.906-7.404 33.83-7.404 46.734 0 12.906 7.403 12.907 19.407 0 26.81-12.904 7.403-33.827 7.403-46.733 0-12.906-7.404-12.906-19.407-.001-26.81Z",
    fill: "url(#EmptySquadChallenge_svg__u)",
    fillRule: "nonzero"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "m139.44 206.035.345-1.813s2.297-2.205 2.297-3.711v-15.965l2.746-1.575v15.965c0 2.557-.844 4.367-2.238 5.286h.005l-3.155 1.813Z",
    fill: "#C85A2B",
    fillRule: "nonzero"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M133.389 205.25c4.875 2.795 8.693.714 8.693-4.74v-15.964l-10.81-6.201v3.15l8.066 4.626v12.815c0 3.748-2.558 5.109-5.95 3.163v3.15Z",
    fill: "#FB944B",
    fillRule: "nonzero"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "m131.272 178.345 2.746-1.575 10.81 6.201-2.746 1.575-10.81-6.201Zm7.55 23.052c-.908 1.77-2.944 2.13-5.433.702l2.745-1.575a5.967 5.967 0 0 0 2.688.873Z",
    fill: "#FFAF6D",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#EmptySquadChallenge_svg__v)",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "multiply"
    },
    d: "M136.091 87.476h-15.593l9.748 5.765-9.748 5.594h15.593l9.897-5.678-9.897-5.68z"
  }), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#B9BEE4",
    fillRule: "nonzero",
    d: "m120.498 98.835 9.748-5.594V66.883l-9.748 5.592v26.36z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#CCD1F6",
    fillRule: "nonzero",
    d: "m120.498 98.835-9.749-5.594V66.883l9.75 5.592v26.36z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#F4F4F9",
    fillRule: "nonzero",
    d: "m120.498 72.475-9.749-5.592 9.75-5.59 9.747 5.59z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#EmptySquadChallenge_svg__w)",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "multiply"
    },
    d: "M436.5 234.62h-30.72l19.205 11.36L405.779 257h30.722L456 245.814l-19.5-11.193z"
  }), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#B9BEE4",
    fillRule: "nonzero",
    d: "m405.78 257 19.205-11.02v-34.226l-19.206 11.016z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#CCD1F6",
    fillRule: "nonzero",
    d: "m405.78 257-19.208-11.02v-34.226l19.207 11.016z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#F4F4F9",
    fillRule: "nonzero",
    d: "m405.78 222.77-19.208-11.016 19.207-11.014 19.206 11.014z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#EmptySquadChallenge_svg__x)",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "multiply"
    },
    d: "M214.48 39.951h-40.497l25.316 14.972-25.316 14.528h40.498l25.703-14.746-25.703-14.754z"
  }), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#B9BEE4",
    fillRule: "nonzero",
    d: "m173.983 69.45 25.316-14.527V14.518L173.983 29.04v40.41z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#CCD1F6",
    fillRule: "nonzero",
    d: "m173.983 69.45-25.32-14.527V14.518l25.32 14.523v40.41z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#F4F4F9",
    fillRule: "nonzero",
    d: "m173.983 29.04-25.32-14.522L173.983 0l25.316 14.518-25.316 14.523z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#EmptySquadChallenge_svg__y)",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "multiply"
    },
    d: "M44.357 120.97H75.94v2.115H44.357z"
  }), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "#34318D",
    fillRule: "nonzero",
    d: "m42.81 93.98 1.547.886v28.22l-1.547-.888V93.98z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "#1E1C6B",
    fillRule: "nonzero",
    d: "m45.904 93.98-1.547.886v28.22l1.547-.888V93.98z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M24.444 83.728c.002-10.927 8.917-19.784 19.914-19.783 10.996 0 19.91 8.858 19.91 19.785s-8.915 19.784-19.911 19.784a19.977 19.977 0 0 1-14.081-5.795 19.72 19.72 0 0 1-5.832-13.991Z",
    fill: "url(#EmptySquadChallenge_svg__z)",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M183.564 11.254c-1.686-.967-3.928-1.413-6.13-1.348h-3.451v.562a9.134 9.134 0 0 0-1.826.786c-3.14 1.814-3.121 4.753.038 6.567a9.2 9.2 0 0 0 1.788.77v.586h4.14c1.991-.033 3.964-.482 5.479-1.355 3.14-1.815 3.123-4.754-.038-6.568Z",
    fill: "url(#EmptySquadChallenge_svg__A)",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "multiply"
    }
  }), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M168.639 17.824c-1.59-.913-2.385-2.11-2.382-3.306l.007-2.727c-.003 1.198.791 2.394 2.381 3.308 3.162 1.812 8.268 1.812 11.408 0 1.56-.902 2.34-2.08 2.344-3.26l-.007 2.725c-.003 1.18-.784 2.358-2.344 3.26-3.14 1.813-8.246 1.813-11.407 0Z",
    fill: "url(#EmptySquadChallenge_svg__B)",
    fillRule: "nonzero"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M168.645 15.099c-3.16-1.813-3.177-4.753-.038-6.566 3.14-1.813 8.25-1.813 11.409 0 3.161 1.813 3.176 4.753.037 6.567-3.14 1.81-8.246 1.81-11.408-.001Z",
    fill: "#FFF",
    fillRule: "nonzero"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "#E9743E",
    fillRule: "nonzero",
    opacity: 0.393,
    d: "m178.47 11.442-5.97.302.186-1.334h-1.65l-.448 2.43 7.881-.452v-.946z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M415.36 208.336c-1.686-.967-3.929-1.413-6.13-1.348h-3.452v.562a9.136 9.136 0 0 0-1.826.786c-3.139 1.814-3.12 4.753.038 6.566a9.201 9.201 0 0 0 1.788.77v.587h4.14c1.992-.033 3.964-.482 5.48-1.355 3.139-1.815 3.122-4.754-.038-6.568Z",
    fill: "url(#EmptySquadChallenge_svg__C)",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "multiply"
    }
  }), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M400.435 214.906c-1.59-.913-2.386-2.11-2.382-3.306l.007-2.727c-.003 1.198.791 2.394 2.38 3.308 3.162 1.812 8.269 1.812 11.408 0 1.56-.902 2.342-2.08 2.345-3.26l-.008 2.725c-.002 1.18-.783 2.358-2.343 3.26-3.14 1.813-8.247 1.813-11.407 0Z",
    fill: "url(#EmptySquadChallenge_svg__D)",
    fillRule: "nonzero"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M400.44 212.18c-3.159-1.812-3.176-4.753-.037-6.565 3.14-1.814 8.249-1.814 11.409 0 3.16 1.812 3.176 4.753.036 6.566-3.14 1.812-8.245 1.812-11.407 0Z",
    fill: "#FFF",
    fillRule: "nonzero"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "#E9743E",
    fillRule: "nonzero",
    opacity: 0.393,
    d: "m410.265 208.524-5.969.302.185-1.333h-1.65l-.447 2.43 7.88-.453v-.946z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M221.2 120.415c-.814.47-1.618.955-2.41 1.458h10.325a16.351 16.351 0 0 1 2.13-6.28l-.007.012a79.188 79.188 0 0 0-10.038 4.81Z",
    fill: "#DAE0F5",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.94 127.739v3.015a45.024 45.024 0 0 0-9.659 4.05c-4.442 2.548-7.64 5.6-9.488 8.887v13.585l-5.632 1.033 26.11.001 2.739-.502v-9.875l1.801-3.229c.176.032.354.055.53.086 1.718-3.704 5.117-7.157 10.05-9.986a45.024 45.024 0 0 1 9.658-4.05l-2.705-3.015H255.94Z",
    fill: "url(#EmptySquadChallenge_svg__E)",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m328.113 121.64-9.91 5.687-.006.003v22.71l-.003-.003c.065 2.961-.7 5.882-2.207 8.437a79.253 79.253 0 0 0 10.083-4.825c6.357-3.647 11.468-7.907 15.132-12.552-1.83-2.666-4.462-5.191-7.91-7.448l5.688-3.263a53.61 53.61 0 0 0-10.866-8.745Z",
    fill: "url(#EmptySquadChallenge_svg__F)",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m371.39 139.496 5.712-.873c-3.61-7.766-10.78-14.89-20.743-20.605a81.72 81.72 0 0 0-5.366-2.805v19.588l.271.04v4.655h20.126Z",
    fill: "url(#EmptySquadChallenge_svg__G)",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.042 201.585v2.752c-16.082 6.642-34.886 10.739-54.453 12.004 1.432.094 2.87.174 4.31.24 27.176 1.189 54.256-3.159 76.253-12.244l-3.454-2.752h-22.656Z",
    fill: "url(#EmptySquadChallenge_svg__H)",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.943 145.422c-1.97-14.808-12.594-28.804-30.05-39.724a41.634 41.634 0 0 1 3.94 12.797c.222 1.683.332 3.38.329 5.077v-.022 26.228c.004.232 0 .465 0 .699v.692c-.247 13.62-7.784 26.93-21.673 37.996h26.11c15.838-12.618 23.418-28.153 21.344-43.743Z",
    fill: "url(#EmptySquadChallenge_svg__I)",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m168.69 151.33 5.368-1.42a62.35 62.35 0 0 0 5.663 6.12h4.89l5.892-.281c-1.039-7.15.062-14.242 3.112-21.012v-10.763.002c-.113-7.274 2.76-14.56 8.619-21.195a112.105 112.105 0 0 0-6.115 3.246c-18.494 10.61-29.592 24.505-31.726 39.223v10.499l-5.892.28h10.19v-4.699Zm24.925-28.06.001.002-.001.183v-.185Z",
    fill: "url(#EmptySquadChallenge_svg__J)",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.94 109.205v6.969c9.3-3.911 19.841-6.417 30.737-7.525a129.132 129.132 0 0 0-30.738.556Z",
    fill: "url(#EmptySquadChallenge_svg__K)",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.69 152.19h-6.898c.792.503 1.595.99 2.408 1.459a75.433 75.433 0 0 0 5.126 2.67 25.221 25.221 0 0 1-.637-4.128Z",
    fill: "#DAE0F5",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.847 174.553a52.496 52.496 0 0 1-2.086 1.835l1.28 1.022v12.438a89.527 89.527 0 0 0 15.32-6.874 71.514 71.514 0 0 0 3.942-2.439l-18.456-5.982Z",
    fill: "url(#EmptySquadChallenge_svg__L)",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "multiply"
    }
  }), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M265.24 186.272c-25.081-1.099-48.755-7.139-67-17.055l20.912-11.996c31.357 16.722 80.58 16.332 111.098-1.174a62.84 62.84 0 0 0 11.597-8.421l25.757 8.35a74.624 74.624 0 0 1-4.913 4.28l4.798 1.982c15.838-12.618 23.418-28.154 21.344-43.743-2.097-15.76-13.995-30.602-33.502-41.793-45.048-25.842-118.346-25.842-163.392 0-24.08 13.814-36.267 32.914-33.438 52.401l5.892-.281c-2.686-18.492 8.878-36.615 31.726-49.722 42.742-24.52 112.289-24.52 155.032 0 18.509 10.618 29.798 24.7 31.787 39.653 1.588 11.934-2.787 23.832-12.425 34.27l-25.759-8.35a36.957 36.957 0 0 0 6.51-9.833l-5.732-.83c-3.257 7.413-9.987 14.203-19.462 19.64-28.912 16.584-75.958 16.584-104.87-.001-13.706-7.863-20.91-18.064-21.62-28.386h29.542c.27 2.153.963 4.232 2.04 6.12l5.63-1.033c-4.437-7.96-.802-16.57 9.49-22.473a45.024 45.024 0 0 1 9.657-4.05l-2.705-3.015a51.934 51.934 0 0 0-11.133 4.667c-7.81 4.48-12.293 10.313-12.986 16.394h-29.536c.71-10.322 7.915-20.522 21.62-28.384 28.213-16.185 73.686-16.574 102.735-1.174l-20.929 12.006a53.935 53.935 0 0 0-8.97-3.51l-2.705 3.017c3.368.97 6.61 2.33 9.66 4.049 15.082 8.652 15.082 22.731 0 31.384-10.292 5.903-25.304 7.99-39.179 5.443l-1.801 3.23c15.992 2.935 33.296.53 45.16-6.276 16.684-9.571 17.348-24.899 2.012-34.936l20.931-12.008c8.164 5.071 14.08 11.21 17.167 17.855l5.713-.874c-3.61-7.765-10.782-14.89-20.744-20.605-31.217-17.908-82.012-17.908-113.23 0-30.516 17.507-31.196 45.745-2.047 63.733L194.06 166.82c-8.275-5.005-14.999-10.685-20.002-16.91l-5.368 1.42c5.704 7.099 13.527 13.527 23.25 19.105 19.506 11.19 45.38 18.016 72.85 19.218 27.175 1.19 54.255-3.158 76.252-12.243l-3.454-2.752c-20.867 8.619-46.56 12.743-72.347 11.614Z",
    fill: "#F6F6FB",
    fillRule: "nonzero"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M265.24 186.272c-25.081-1.099-48.755-7.139-67-17.055l20.912-11.996c31.357 16.722 80.58 16.332 111.098-1.174a62.84 62.84 0 0 0 11.597-8.421l25.757 8.35a74.624 74.624 0 0 1-4.913 4.28l4.798 1.982c15.838-12.618 23.418-28.154 21.344-43.743-2.097-15.76-13.995-30.602-33.502-41.793-45.048-25.842-118.346-25.842-163.392 0-24.08 13.814-36.267 32.914-33.438 52.401l5.892-.281c-2.686-18.492 8.878-36.615 31.726-49.722 42.742-24.52 112.289-24.52 155.032 0 18.509 10.618 29.798 24.7 31.787 39.653 1.588 11.934-2.787 23.832-12.425 34.27l-25.759-8.35a36.957 36.957 0 0 0 6.51-9.833l-5.732-.83c-3.257 7.413-9.987 14.203-19.462 19.64-28.912 16.584-75.958 16.584-104.87-.001-13.706-7.863-20.91-18.064-21.62-28.386h29.542c.27 2.153.963 4.232 2.04 6.12l5.63-1.033c-4.437-7.96-.802-16.57 9.49-22.473a45.024 45.024 0 0 1 9.657-4.05l-2.705-3.015a51.934 51.934 0 0 0-11.133 4.667c-7.81 4.48-12.293 10.313-12.986 16.394h-29.536c.71-10.322 7.915-20.522 21.62-28.384 28.213-16.185 73.686-16.574 102.735-1.174l-20.929 12.006a53.935 53.935 0 0 0-8.97-3.51l-2.705 3.017c3.368.97 6.61 2.33 9.66 4.049 15.082 8.652 15.082 22.731 0 31.384-10.292 5.903-25.304 7.99-39.179 5.443l-1.801 3.23c15.992 2.935 33.296.53 45.16-6.276 16.684-9.571 17.348-24.899 2.012-34.936l20.931-12.008c8.164 5.071 14.08 11.21 17.167 17.855l5.713-.874c-3.61-7.765-10.782-14.89-20.744-20.605-31.217-17.908-82.012-17.908-113.23 0-30.516 17.507-31.196 45.745-2.047 63.733L194.06 166.82c-8.275-5.005-14.999-10.685-20.002-16.91l-5.368 1.42c5.704 7.099 13.527 13.527 23.25 19.105 19.506 11.19 45.38 18.016 72.85 19.218 27.175 1.19 54.255-3.158 76.252-12.243l-3.454-2.752c-20.867 8.619-46.56 12.743-72.347 11.614Z",
    fill: "#F6F6FB",
    fillRule: "nonzero"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M193.615 150.364c-.023 4.878 1.307 9.755 3.968 14.435l17.39-9.976c-14.069-8.681-21.188-19.75-21.358-30.85v26.391Z",
    fill: "#CED3F8",
    fillRule: "nonzero"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "nonzero",
    d: "m193.615 123.455.001-.183-.001-.002z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M330.25 156.047c-30.517 17.506-79.74 17.896-111.098 1.174v20.903c14.028 4.613 29.755 7.433 46.089 8.148 25.786 1.13 51.48-2.995 72.347-11.614l2.173 1.73a52.497 52.497 0 0 0 2.086-1.835v-26.927a62.84 62.84 0 0 1-11.597 8.42Z",
    fill: "url(#EmptySquadChallenge_svg__M)",
    fillRule: "nonzero"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "m351.264 150.68-9.417-3.054v26.927l20.844 6.757v-21.054a71.828 71.828 0 0 0 4.913-4.28l-16.34-5.296Z",
    fill: "#BBC0E6",
    fillRule: "nonzero"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "#BBC0E6",
    fillRule: "nonzero",
    d: "M362.691 160.256v26.927l4.798 1.982v-26.927l-4.798-1.982z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M367.489 162.238v26.927c13.89-11.066 21.426-24.375 21.672-37.996l.001-.003v-.69c0-.233.004-.466 0-.698V123.55c0 13.862-7.55 27.435-21.673 38.688Z",
    fill: "#A5ABCC",
    fillRule: "nonzero"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M300.99 107.877a45.098 45.098 0 0 0-9.66-4.05v26.927c3.368.97 6.61 2.33 9.66 4.05a32.735 32.735 0 0 1 3.389 2.226c11.582-8.693 10.459-21.209-3.39-29.153Zm-101.41 17.386c.667 9.696 7.064 19.283 19.197 26.927h10.345v-26.927h-29.543Z",
    fill: "#BBC0E6",
    fillRule: "nonzero"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M229.122 125.263v26.927a16.52 16.52 0 0 0 2.04 6.12v-26.927a16.522 16.522 0 0 1-2.04-6.12Z",
    fill: "#CED3F8",
    fillRule: "nonzero"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fill: "#BBC0E6",
    fillRule: "nonzero",
    d: "M231.161 131.383v26.926l5.632-1.033V130.35z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M246.281 107.877c-10.29 5.903-13.926 14.514-9.488 22.473v13.341c1.848-3.286 5.046-6.34 9.488-8.888a45.024 45.024 0 0 1 9.658-4.049v-26.926a45.024 45.024 0 0 0-9.658 4.049Z",
    fill: "url(#EmptySquadChallenge_svg__N)",
    fillRule: "nonzero"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M221.2 93.489c-13.706 7.862-20.91 18.062-21.62 28.384h19.21a67.796 67.796 0 0 1 2.41-1.458 79.188 79.188 0 0 1 10.038-4.81c2.14-3.743 5.797-7.22 10.863-10.126a51.934 51.934 0 0 1 11.133-4.667l2.705 3.016v5.377a128.97 128.97 0 0 1 35.39.004v-5.381l2.705-3.016c3.09.9 6.093 2.075 8.971 3.51l20.93-12.007c-29.05-15.4-74.523-15.011-102.735 1.174Z",
    fill: "url(#EmptySquadChallenge_svg__O)",
    fillRule: "nonzero"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M351.264 134.84a36.957 36.957 0 0 1-6.51 9.834l6.51 2.11V134.84Z",
    fill: "#A5ABCC",
    fillRule: "nonzero"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M264.79 189.653c-27.47-1.202-53.344-8.028-72.85-19.218-9.723-5.578-17.545-12.006-23.25-19.105v26.927c5.704 7.1 13.527 13.528 23.25 19.104 19.506 11.19 45.38 18.016 72.85 19.22 27.175 1.189 54.255-3.16 76.252-12.244V177.41c-21.997 9.085-49.077 13.433-76.252 12.243Z",
    fill: "url(#EmptySquadChallenge_svg__P)",
    fillRule: "nonzero"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "m328.113 94.714-20.931 12.008c7.254 4.748 10.924 10.68 11.015 16.625l.005.003v3.977l9.911-5.686V94.714Z",
    fill: "#A5ABCC",
    fillRule: "nonzero"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M318.197 123.348c.103 6.624-4.235 13.267-13.027 18.31-6.749 3.871-15.256 6.316-24.281 7.167l-.812.182-.845-.045a76.665 76.665 0 0 1-19.222-1.029v17.43c19.137 2.037 39.4-.262 55.975-6.885a15.915 15.915 0 0 0 2.21-8.441l.002.003v-22.71l.005-.003v-3.977l-.005-.002Z",
    fill: "url(#EmptySquadChallenge_svg__Q)",
    fillRule: "nonzero"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M328.113 94.714v26.927c7.143 4.437 12.563 9.69 15.876 15.385.468-.809.898-1.638 1.29-2.486V112.57c-3.087-6.646-9.002-12.784-17.166-17.855Z",
    fill: "#C2C7E5",
    fillRule: "nonzero"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M345.28 112.569v21.971c.082-.177.174-.351.252-.529l5.46.79v-23.106l-5.712.874Z",
    fill: "#A5ABCC",
    fillRule: "nonzero"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M158.113 124.147v25.339l.01-.001c-.06 2.188.067 4.377.379 6.545v-26.927a38.613 38.613 0 0 1-.39-4.956Z",
    fill: "#CED3F8",
    fillRule: "nonzero"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M382.938 118.753C380.95 103.8 369.66 89.718 351.151 79.1c-42.743-24.52-112.29-24.52-155.032 0-22.848 13.107-34.412 31.23-31.726 49.722v16.428c2.134-14.717 13.232-28.614 31.726-39.223a106.762 106.762 0 0 1 6.116-3.246c3.723-4.217 8.65-8.171 14.784-11.69 31.218-17.91 82.013-17.91 113.23 0 5.995 3.438 10.972 7.391 14.777 11.684a112.026 112.026 0 0 1 6.125 3.252c14.891 8.543 25.101 19.33 29.562 31.007a37.118 37.118 0 0 0 2.225-18.281Z",
    fill: "url(#EmptySquadChallenge_svg__R)",
    fillRule: "nonzero"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fill: "#BBC0E6",
    fillRule: "nonzero",
    d: "m161.087 128.98-.446.021-2.14.102v26.927l5.892-.281v-26.927l-3.306.158z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M198.24 169.217a126.825 126.825 0 0 0 20.912 8.918V157.22l-20.912 11.996Z",
    fill: "#ADB5DB",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m338.98 130.386-10.866-35.672v26.927a53.61 53.61 0 0 1 10.866 8.745Zm-139.4-5.123c.667 9.696 7.064 19.283 19.197 26.927h6.912l-26.11-26.927Zm160.723 55.272-18.456-32.91v26.928l18.456 5.982Z",
    fill: "#E8ECF7",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(254.002 62.928)"
  }, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "EmptySquadChallenge_svg__T",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EmptySquadChallenge_svg__S"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#EmptySquadChallenge_svg__T)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#EmptySquadChallenge_svg__U)",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "multiply"
    },
    d: "M26.778 77.809h-10.64l-4.931 4.632h15.571z",
    transform: "translate(7.356 5.961)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#EmptySquadChallenge_svg__V)",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "multiply"
    },
    d: "M18.1 73.076H7.46l-4.931 4.632H18.1z",
    transform: "translate(7.356 5.961)"
  }), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M16.173 75.83c1.224 0 1.882 1.855 1.482 3.152-.302.471-1.175 1.012-1.175 1.012s-3.518 2.146-4.355 2.352c-.837.204-2.772.195-3.161-1.22 0-.902.66-1.543 1.483-2.23 1.076-.896 1.972-1.798 2.855-2.423.724-.512 2.87-.643 2.87-.643Z",
    fill: "url(#EmptySquadChallenge_svg__W)",
    fillRule: "nonzero",
    transform: "translate(7.356 5.961)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M19.444 87.918c.862-.21 4.482-2.42 4.482-2.42.442-.271.838-.608 1.176-.999-.018.15-.048.3-.092.445-.301.47-1.174 1.01-1.174 1.01s-3.518 2.148-4.356 2.353c-.837.204-2.771.195-3.16-1.22 0-.032.005-.06.007-.09.595 1.119 2.328 1.114 3.117.92Z",
    fill: "#1E1C6B",
    fillRule: "nonzero"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M20.751 80.937c.596 0 2.701.53 2.701.53.017.193.08.38.187.542l.06.07c.415.288.892.837-.148 1.355-2.013 1.006-4.054-.116-3.297-.727.507-.41.497-1.31.497-1.77Z",
    fill: "#FFD0A4",
    fillRule: "nonzero"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M19.955 82.98c.125-.235.386-.78 1.11-.426.753.369 1.002.921 1.002 1.414 0 .493-1.456.365-1.52.3-.065-.064-.592-1.289-.592-1.289Z",
    fill: "#4141AA",
    fillRule: "nonzero"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M21.184 84.888a.339.339 0 0 1-.28-.145 2.93 2.93 0 0 0-1.494-1.037.336.336 0 1 1 .16-.654 3.585 3.585 0 0 1 1.892 1.308c.071.103.08.237.021.348a.339.339 0 0 1-.3.18Zm-1.056.937a.339.339 0 0 1-.28-.145 2.933 2.933 0 0 0-1.494-1.036.335.335 0 0 1-.168-.561.34.34 0 0 1 .327-.093 3.592 3.592 0 0 1 1.892 1.308c.072.103.08.236.022.347a.339.339 0 0 1-.3.18Z",
    fill: "#FFF",
    fillRule: "nonzero"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M7.622 71.101c1.225 0 1.884 1.856 1.484 3.153-.302.472-1.175 1.011-1.175 1.011s-3.518 2.147-4.356 2.352c-.836.205-2.772.195-3.16-1.22 0-.902.658-1.543 1.483-2.229 1.075-.895 1.972-1.8 2.854-2.423.725-.512 2.87-.643 2.87-.643Z",
    fill: "url(#EmptySquadChallenge_svg__X)",
    fillRule: "nonzero",
    transform: "translate(7.356 5.961)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M10.895 83.19c.862-.211 4.482-2.42 4.482-2.42.441-.271.837-.608 1.175-.998a2.59 2.59 0 0 1-.091.443c-.302.472-1.175 1.011-1.175 1.011s-3.518 2.147-4.355 2.352c-.837.205-2.772.196-3.161-1.22 0-.03.006-.06.007-.09.595 1.12 2.33 1.115 3.118.921Z",
    fill: "#1E1C6B",
    fillRule: "nonzero"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2 76.208c.598 0 2.703.532 2.703.532.016.193.08.378.187.54.021.024.039.048.059.072.415.287.891.836-.147 1.354-2.013 1.006-4.054-.115-3.298-.726.509-.412.497-1.311.497-1.772Z",
    fill: "#FFD0A4",
    fillRule: "nonzero"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M11.406 78.252c.124-.235.385-.78 1.108-.426.755.369 1.003.921 1.003 1.414 0 .493-1.456.365-1.52.3-.065-.063-.591-1.288-.591-1.288Z",
    fill: "#4141AA",
    fillRule: "nonzero"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M12.634 80.16a.34.34 0 0 1-.28-.144 2.945 2.945 0 0 0-1.494-1.039.335.335 0 0 1-.165-.56.34.34 0 0 1 .326-.093 3.592 3.592 0 0 1 1.89 1.309c.072.103.08.237.022.347a.339.339 0 0 1-.3.18Zm-1.056.938a.339.339 0 0 1-.28-.145 2.93 2.93 0 0 0-1.493-1.037.335.335 0 0 1-.173-.564.34.34 0 0 1 .332-.09 3.586 3.586 0 0 1 1.892 1.308c.072.103.08.237.021.348a.339.339 0 0 1-.3.18Z",
    fill: "#FFF",
    fillRule: "nonzero"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M2.49 56.396c-.053-4.779.802-14.366 1.372-20.345 1.592.768 12.606 1.619 14.389 2.295.804 7.315.102 15.409-.776 22.546.829 4.808-.368 8.695-.837 14.185-.273 1.48-2.304 1.89-3.584.811-.283-4.19-.599-7.987-.92-13.875-.505-4.563-1.872-9.196-2.487-12.954-.341 1.891-1.256 4.782-1.59 7.853.334 4.69.907 7.915.27 14.02-.571 1.392-2.644 1.38-3.674.063-.432-4.802-2.12-10.598-2.164-14.599Z",
    fill: "url(#EmptySquadChallenge_svg__Y)",
    transform: "translate(7.356 5.961)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m8.317 55.102.004.006c.416-2.376 1.053-4.535 1.326-6.05-.17-1.092-.39-2.677-.39-2.677-.385 1.694-1.33 7.796-.94 8.721Z",
    fill: "#D1D7F3",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "multiply"
    },
    transform: "translate(7.356 5.961)"
  }), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M8.675 36.113c-.874 1.619.147 2.654 1.472 2.521.752-.075-.108-2.088-.108-2.088l-1.364-.433Z",
    fill: "#FCD1A9",
    fillRule: "nonzero"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M14.92 18.76c-3.488 1.014-6.393 5.944-7.281 10.427-.602 3.036-.377 6.974 1.982 8.138 3.99-2.47 5.299-18.565 5.299-18.565Z",
    fill: "#E8ECF7",
    fillRule: "nonzero"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M17.526 16.453c-1.357-1.688-4.691-4.042-6.875-4.202-3.713-.272-6.654 2.777-7.412 5.325-.715 2.398-.182 15.804.311 19.882.393 1.72 2.144 2.493 3.353 2.744 5.278 1.098 11.405.716 11.63-2.362.45-6.202.951-19.442-1.007-21.387Z",
    fill: "url(#EmptySquadChallenge_svg__Z)",
    fillRule: "nonzero",
    transform: "translate(7.356 5.961)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M15.328 15.667c1.168-.238 2.748-.11 3.479 3.404.648 3.119.136 12.977-2.055 15.166-1.76 1.758-8.147.915-13.86-1.421-.576-.765-.844-1.917 0-2.531 3.917-.123 7.652.474 10.704.196.227-2.533-.09-8.315-.164-10.199-.107-2.787.743-4.38 1.897-4.615Z",
    fill: "url(#EmptySquadChallenge_svg__aa)",
    fillRule: "nonzero",
    transform: "translate(7.356 5.961)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M18.474 13.314c.136-1.195-4.022 1.24-3.855 2.818.136 1.284.513 2.414-.794 3.218-.45.359-1.993 2.855.379 2.882 3.391.04 4.296-.884 6.748-2.972-1.462-.82-2.918-2.07-2.478-5.946Z",
    fill: "#FCD1A9",
    fillRule: "nonzero"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "m19.454 12.607-1.69-2.362h-7.352v4.398c0 2.43 1.646 4.397 3.675 4.397 1.972 0 3.802-1.621 3.897-3.948l.892-.307.578-2.178Z",
    fill: "#FCD1A9",
    fillRule: "nonzero"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M14.259 20.217c1.756 0 3.93-2.804 3.725-5.124a4.226 4.226 0 0 1-3.75 3.944c-.127.115-.264.22-.41.313a1.067 1.067 0 0 0-.122.123c0 .355.237.744.556.744Z",
    fill: "#F2C39D",
    fillRule: "nonzero"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M10.841 8.26c-.672-.117-.733-.672 1.992-1.61 1.584-.772 3.829-1.008 5.282-.115 1.968 1.212 2.562 2.991 2.209 5.225-.35 2.235-1.792 4.36-1.792 4.36-.218.218-.25-.812-.073-1.575.138-.194.226-.418.257-.653.521-2.27-.877-1.931-1.068-1.74-.431.176.403 2.055-.861 1.867-.61-.089-.528-1.785-.525-2.381a2.529 2.529 0 0 0-.276.071c-1.043.576-4.589.995-2.62-.229-1.371 0-3.24.63-3.871-.235-.75-1.03.451-2.151 1.346-2.985Z",
    fill: "#20196F",
    fillRule: "nonzero"
  }))))));
};
export default SvgEmptySquadChallenge;